module.exports = __webpack_public_path__ + "media/colonic wall cyst.b1c56e5e.wav";